<script setup lang="ts">
import { computed } from "vue";
import type { CompanyDetails as CompanyDetailsType } from "../types";
import CompanyDetails from "./CompanyDetails.vue";
import CompanyLogo from "./CompanyLogo.vue";

const props = defineProps<{
  isInitialised: boolean;
  clientRequestError: boolean;
  isDesktop: boolean;
  companyDetails: CompanyDetailsType | null;
  showCookieLink?: boolean;
}>();

const backgroundColor = computed(() => {
  if (
    props.companyDetails?.light_css &&
    props.companyDetails?.brand_colour_main
  ) {
    return props.companyDetails?.brand_colour_main;
  }
  return "#ffffff";
});
</script>

<template>
  <div
    data-testid="desktop-sidebar"
    class="side-bar-container"
    :class="{ 'light-css': companyDetails?.light_css }"
    :style="{ backgroundColor }"
  >
    <div>
      <template
        v-if="
          isInitialised && !clientRequestError
        "
      >
        <CompanyLogo :companyDetails="companyDetails" class="company-logo" />
        <slot name="client-request-details"></slot>
        <slot name="steps"></slot>
      </template>
    </div>
    <CompanyDetails
      v-if="companyDetails"
      data-testid="company-details"
      class="company-details"
      :isInitialised="isInitialised"
      :clientRequestError="clientRequestError" 
      :isDesktop="isDesktop"
      :companyDetails="companyDetails"
      :showCookieLink="showCookieLink"
    />
  </div>
</template>

<style scoped lang="scss">
.side-bar-container {
  width: 378px;
  border-radius: 8px;
  margin: $spacing-s;
  padding: $spacing-l;
  color: $color-neutral-900;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0px 0px 250px 0px rgba(0, 0, 0, 0.1);
}
.company-logo {
  padding: 0 0 $spacing-s;
}
.company-details {
  align-self: flex-start;
}
.light-css {
  color: $color-neutral-0;
}
</style>
